// /app/frontend/src/App.js
// Frugal V2 - Clean App Entry Point with Landing Page

import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import FrugalDashboardV2 from './components/frugal-v2/pages/FrugalDashboardV2';
import LoginPage from './components/frugal-v2/pages/LoginPage';
import AdminPanel from './components/frugal-v2/pages/AdminPanel';
import LandingPage from './components/LandingPage';
import './App.css';

function ProtectedRoute({ children }) {
  const [status, setStatus] = useState('checking'); // checking | ok | denied
  
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setStatus('denied');
      return;
    }
    // Validate token is not expired locally
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp * 1000 < Date.now()) {
        localStorage.removeItem('token');
        setStatus('denied');
      } else {
        setStatus('ok');
      }
    } catch {
      setStatus('ok'); // Let backend validate
    }
  }, []);

  if (status === 'checking') return null;
  if (status === 'denied') return <Navigate to="/login" />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route 
          path="/dashboard" 
          element={<ProtectedRoute><FrugalDashboardV2 /></ProtectedRoute>} 
        />
        <Route 
          path="/admin" 
          element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} 
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
